import React, { HTMLAttributes } from 'react';

export type IconName =
    | 'account'
    | 'account-check-outline'
    | 'account-plus'
    | 'account-check'
    | 'check-circle'
    | 'times'
    | 'times-circle'
    | 'warning-circle'
    | 'security'
    | 'security-special'
    | 'deposit'
    | 'histogram'
    | 'arrow-left'
    | 'info'
    | 'search'
    | 'timer'
    | 'bet'
    | 'users'
    | 'add-party'
    | 'settings'
    | 'user'
    | 'lock'
    | 'unlock'
    | 'check';

interface Props {
    name: IconName;
    height?: number;
    width?: number;
    className?: string;
    onClick?(): void;
}

export type IconProps = HTMLAttributes<SVGElement> & Props;

// Notice here we're using the function declaration with the interface Props
const SvgIcon: React.FunctionComponent<Props> = ({
    onClick,
    name,
    width = 48,
    height = 48,
    className,
    ...svgProps
}: Props) => {
    switch (name) {
        case 'account':
            return (
                <svg
                    onClick={onClick}
                    width={width}
                    height={height}
                    viewBox="0 0 48 48"
                    {...svgProps}
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                >
                    <path
                        d="M12.9999 14.846C15.5489 14.846 17.6153 12.7796 17.6153 10.2306C17.6153 7.68161 15.5489 5.61523 12.9999 5.61523C10.4509 5.61523 8.38452 7.68161 8.38452 10.2306C8.38452 12.7796 10.4509 14.846 12.9999 14.846Z"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M5.11694 22.0464C5.94077 20.6941 7.09862 19.5765 8.47917 18.801C9.85972 18.0255 11.4166 17.6182 13 17.6182C14.5835 17.6182 16.1403 18.0255 17.5209 18.801C18.9014 19.5765 20.0593 20.6941 20.8831 22.0464"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25Z"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
            break;
        case 'account-check-outline':
            return (
                <svg
                    onClick={onClick}
                    width={width}
                    height={height}
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="48" height="48" rx="24" fill="currentColor" fillOpacity="0.16" />
                    <path
                        opacity="0.15"
                        d="M24 23C26.2091 23 28 21.2091 28 19C28 16.7909 26.2091 15 24 15C21.7909 15 20 16.7909 20 19C20 21.2091 21.7909 23 24 23Z"
                        fill="currentColor"
                    />
                    <path
                        d="M35.5303 21.5303C35.8232 21.2374 35.8232 20.7626 35.5303 20.4697C35.2374 20.1768 34.7626 20.1768 34.4697 20.4697L35.5303 21.5303ZM31.8001 24.1999L31.2697 24.7303C31.5626 25.0232 32.0375 25.0231 32.3304 24.7303L31.8001 24.1999ZM30.5303 21.8696C30.2375 21.5767 29.7626 21.5767 29.4697 21.8696C29.1768 22.1625 29.1768 22.6374 29.4697 22.9303L30.5303 21.8696ZM32 33V33.75C32.4142 33.75 32.75 33.4142 32.75 33H32ZM16 33H15.25C15.25 33.4142 15.5858 33.75 16 33.75V33ZM34.4697 20.4697L31.2697 23.6696L32.3304 24.7303L35.5303 21.5303L34.4697 20.4697ZM29.4697 22.9303L31.2697 24.7303L32.3304 23.6696L30.5303 21.8696L29.4697 22.9303ZM20 27.75H28V26.25H20V27.75ZM31.25 31V33H32.75V31H31.25ZM16.75 33V31H15.25V33H16.75ZM28 27.75C29.7949 27.75 31.25 29.2051 31.25 31H32.75C32.75 28.3766 30.6234 26.25 28 26.25V27.75ZM20 26.25C17.3766 26.25 15.25 28.3766 15.25 31H16.75C16.75 29.2051 18.2051 27.75 20 27.75V26.25ZM27.25 19C27.25 20.7949 25.7949 22.25 24 22.25V23.75C26.6234 23.75 28.75 21.6234 28.75 19H27.25ZM24 22.25C22.2051 22.25 20.75 20.7949 20.75 19H19.25C19.25 21.6234 21.3766 23.75 24 23.75V22.25ZM20.75 19C20.75 17.2051 22.2051 15.75 24 15.75V14.25C21.3766 14.25 19.25 16.3766 19.25 19H20.75ZM24 15.75C25.7949 15.75 27.25 17.2051 27.25 19H28.75C28.75 16.3766 26.6234 14.25 24 14.25V15.75ZM16 33.75H32V32.25H16V33.75Z"
                        fill="currentColor"
                    />
                </svg>
            );
            break;
        case 'account-plus':
            return (
                <svg
                    onClick={onClick}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        opacity="0.15"
                        d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                        fill="white"
                    ></path>
                    <path
                        d="M20.75 8.5C20.75 8.08579 20.4142 7.75 20 7.75C19.5858 7.75 19.25 8.08579 19.25 8.5H20.75ZM19.25 13.5C19.25 13.9142 19.5858 14.25 20 14.25C20.4142 14.25 20.75 13.9142 20.75 13.5H19.25ZM17.5 10.25C17.0858 10.25 16.75 10.5858 16.75 11C16.75 11.4142 17.0858 11.75 17.5 11.75V10.25ZM22.5 11.75C22.9142 11.75 23.25 11.4142 23.25 11C23.25 10.5858 22.9142 10.25 22.5 10.25V11.75ZM20 21V21.75C20.4142 21.75 20.75 21.4142 20.75 21H20ZM4 21H3.25C3.25 21.4142 3.58579 21.75 4 21.75V21ZM19.25 8.5V13.5H20.75V8.5H19.25ZM17.5 11.75H22.5V10.25H17.5V11.75ZM8 15.75H16V14.25H8V15.75ZM19.25 19V21H20.75V19H19.25ZM4.75 21V19H3.25V21H4.75ZM16 15.75C17.7949 15.75 19.25 17.2051 19.25 19H20.75C20.75 16.3766 18.6234 14.25 16 14.25V15.75ZM8 14.25C5.37665 14.25 3.25 16.3766 3.25 19H4.75C4.75 17.2051 6.20507 15.75 8 15.75V14.25ZM15.25 7C15.25 8.79493 13.7949 10.25 12 10.25V11.75C14.6234 11.75 16.75 9.62335 16.75 7H15.25ZM12 10.25C10.2051 10.25 8.75 8.79493 8.75 7H7.25C7.25 9.62335 9.37665 11.75 12 11.75V10.25ZM8.75 7C8.75 5.20507 10.2051 3.75 12 3.75V2.25C9.37665 2.25 7.25 4.37665 7.25 7H8.75ZM12 3.75C13.7949 3.75 15.25 5.20507 15.25 7H16.75C16.75 4.37665 14.6234 2.25 12 2.25V3.75ZM4 21.75H20V20.25H4V21.75Z"
                        fill="white"
                    ></path>
                </svg>
            );
            break;
        case 'account-check':
            return (
                <svg
                    onClick={onClick}
                    width={width}
                    height={height}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M25 14.8457L17.3938 24.9995L12.3169 21.1965"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M9.30814 9.30769C11.6022 9.30769 13.462 7.44795 13.462 5.15385C13.462 2.85974 11.6022 1 9.30814 1C7.01404 1 5.1543 2.85974 5.1543 5.15385C5.1543 7.44795 7.01404 9.30769 9.30814 9.30769Z"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M5.61563 23.1536H1.00024V20.3844C1.00169 18.7423 1.48971 17.1375 2.40267 15.7727C3.31563 14.4078 4.61257 13.3442 6.12971 12.716C7.64684 12.0878 9.3161 11.9233 10.9267 12.2432C12.5372 12.5632 14.0169 13.3532 15.1787 14.5136"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
            break;
        case 'times':
            return (
                <svg
                    onClick={onClick}
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    height="1em"
                    viewBox="0 0 384 512"
                >
                    <path
                        d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                        fill="currentColor"
                    />
                </svg>
            );
        case 'check-circle':
            return (
                <svg onClick={onClick} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
                </svg>
            );
        case 'times-circle':
            return (
                <svg onClick={onClick} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" />
                </svg>
            );
        case 'warning-circle':
            return (
                <svg onClick={onClick} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" />
                </svg>
            );
        case 'arrow-left':
            return (
                <svg
                    onClick={onClick}
                    xmlns="http://www.w3.org/2000/svg"
                    width={width}
                    height={height}
                    fill="currentColor"
                    className="bi bi-arrow-left"
                    viewBox="0 0 16 16"
                >
                    <path
                        fillRule="evenodd"
                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5a.5.5 0 0 0 .5-.5z"
                    />
                </svg>
            );
        case 'security':
            return (
                <svg
                    onClick={onClick}
                    width={width}
                    height={height}
                    xmlSpace="preserve"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        opacity="0.15"
                        d="M16 19L24 15L32 19C32 24.1932 29.2157 31.5098 24 33C18.7843 31.5098 16 24.1932 16 19Z"
                        fill="currentColor"
                    />
                    <path
                        d="M28.0303 22.0303C28.3232 21.7374 28.3232 21.2626 28.0303 20.9697C27.7374 20.6768 27.2626 20.6768 26.9697 20.9697L28.0303 22.0303ZM23 26L22.4697 26.5303C22.7626 26.8232 23.2374 26.8232 23.5303 26.5303L23 26ZM22.0303 23.9697C21.7374 23.6768 21.2626 23.6768 20.9697 23.9697C20.6768 24.2626 20.6768 24.7374 20.9697 25.0303L22.0303 23.9697ZM24 15L24.3354 14.3292C24.1243 14.2236 23.8757 14.2236 23.6646 14.3292L24 15ZM16 19L15.6646 18.3292C15.4105 18.4562 15.25 18.7159 15.25 19H16ZM32 19H32.75C32.75 18.7159 32.5895 18.4562 32.3354 18.3292L32 19ZM24 33L23.794 33.7211C23.9286 33.7596 24.0714 33.7596 24.206 33.7211L24 33ZM26.9697 20.9697L22.4697 25.4697L23.5303 26.5303L28.0303 22.0303L26.9697 20.9697ZM20.9697 25.0303L22.4697 26.5303L23.5303 25.4697L22.0303 23.9697L20.9697 25.0303ZM23.6646 14.3292L15.6646 18.3292L16.3354 19.6708L24.3354 15.6708L23.6646 14.3292ZM32.3354 18.3292L24.3354 14.3292L23.6646 15.6708L31.6646 19.6708L32.3354 18.3292ZM24.206 33.7211C27.0961 32.8954 29.2292 30.4864 30.6251 27.7272C32.0265 24.9571 32.75 21.7136 32.75 19H31.25C31.25 21.4796 30.5813 24.491 29.2867 27.0501C27.9865 29.62 26.1196 31.6144 23.794 32.2789L24.206 33.7211ZM15.25 19C15.25 21.7136 15.9735 24.9571 17.3749 27.7272C18.7708 30.4864 20.9039 32.8954 23.794 33.7211L24.206 32.2789C21.8804 31.6144 20.0135 29.62 18.7133 27.0501C17.4187 24.491 16.75 21.4796 16.75 19H15.25Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case 'security-special':
            return (
                <svg
                    onClick={onClick}
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="48" height="48" rx="24" fill="#59C377" fillOpacity="0.16" />
                    <path
                        opacity="0.15"
                        d="M16 19L24 15L32 19C32 24.1932 29.2157 31.5098 24 33C18.7843 31.5098 16 24.1932 16 19Z"
                        fill="#59C377"
                    />
                    <path
                        d="M28.0303 22.0303C28.3232 21.7374 28.3232 21.2626 28.0303 20.9697C27.7374 20.6768 27.2626 20.6768 26.9697 20.9697L28.0303 22.0303ZM23 26L22.4697 26.5303C22.7626 26.8232 23.2374 26.8232 23.5303 26.5303L23 26ZM22.0303 23.9697C21.7374 23.6768 21.2626 23.6768 20.9697 23.9697C20.6768 24.2626 20.6768 24.7374 20.9697 25.0303L22.0303 23.9697ZM24 15L24.3354 14.3292C24.1243 14.2236 23.8757 14.2236 23.6646 14.3292L24 15ZM16 19L15.6646 18.3292C15.4105 18.4562 15.25 18.7159 15.25 19H16ZM32 19H32.75C32.75 18.7159 32.5895 18.4562 32.3354 18.3292L32 19ZM24 33L23.794 33.7211C23.9286 33.7596 24.0714 33.7596 24.206 33.7211L24 33ZM26.9697 20.9697L22.4697 25.4697L23.5303 26.5303L28.0303 22.0303L26.9697 20.9697ZM20.9697 25.0303L22.4697 26.5303L23.5303 25.4697L22.0303 23.9697L20.9697 25.0303ZM23.6646 14.3292L15.6646 18.3292L16.3354 19.6708L24.3354 15.6708L23.6646 14.3292ZM32.3354 18.3292L24.3354 14.3292L23.6646 15.6708L31.6646 19.6708L32.3354 18.3292ZM24.206 33.7211C27.0961 32.8954 29.2292 30.4864 30.6251 27.7272C32.0265 24.9571 32.75 21.7136 32.75 19H31.25C31.25 21.4796 30.5813 24.491 29.2867 27.0501C27.9865 29.62 26.1196 31.6144 23.794 32.2789L24.206 33.7211ZM15.25 19C15.25 21.7136 15.9735 24.9571 17.3749 27.7272C18.7708 30.4864 20.9039 32.8954 23.794 33.7211L24.206 32.2789C21.8804 31.6144 20.0135 29.62 18.7133 27.0501C17.4187 24.491 16.75 21.4796 16.75 19H15.25Z"
                        fill="#59C377"
                    />
                </svg>
            );
        case 'deposit':
            return (
                <svg
                    onClick={onClick}
                    width="15"
                    height="18"
                    viewBox="0 0 15 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M11.88 6.12012H13.16C13.3297 6.12012 13.4925 6.18755 13.6125 6.30757C13.7326 6.42759 13.8 6.59038 13.8 6.76012V16.3601C13.8 16.5299 13.7326 16.6926 13.6125 16.8127C13.4925 16.9327 13.3297 17.0001 13.16 17.0001H1.64C1.47026 17.0001 1.30748 16.9327 1.18745 16.8127C1.06743 16.6926 1 16.5299 1 16.3601V6.76012C1 6.59038 1.06743 6.42759 1.18745 6.30757C1.30748 6.18755 1.47026 6.12012 1.64 6.12012H2.92"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M7.39941 1V11.24"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M4.83984 8.67969L7.39984 11.2397L9.95984 8.67969"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case 'histogram':
            return (
                <svg
                    onClick={onClick}
                    width="25"
                    height="26"
                    viewBox="0 0 25 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M1.9043 12.1411L23.1187 2.49316"
                        stroke="#fff"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M19.1523 1L23.1185 2.49424L21.6427 6.46042"
                        stroke="#fff"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M24.0596 25H19.4477V12.0869C19.4477 11.8422 19.5449 11.6076 19.7179 11.4346C19.8909 11.2617 20.1255 11.1645 20.3701 11.1645H23.1372C23.3818 11.1645 23.6164 11.2617 23.7894 11.4346C23.9624 11.6076 24.0596 11.8422 24.0596 12.0869V25Z"
                        stroke="#fff"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M14.8359 25H10.2241V14.854C10.2241 14.6093 10.3213 14.3747 10.4943 14.2017C10.6672 14.0288 10.9018 13.9316 11.1465 13.9316H13.9136C14.1582 13.9316 14.3928 14.0288 14.5658 14.2017C14.7388 14.3747 14.8359 14.6093 14.8359 14.854L14.8359 25Z"
                        stroke="#fff"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M5.6123 25H1.00047L1.00047 17.6211C1.00047 17.3764 1.09765 17.1418 1.27062 16.9688C1.4436 16.7959 1.67821 16.6987 1.92284 16.6987H4.68994C4.93456 16.6987 5.16917 16.7959 5.34215 16.9688C5.51513 17.1418 5.6123 17.3764 5.6123 17.6211L5.6123 25Z"
                        stroke="#fff"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case 'info':
            return (
                <svg
                    width="24"
                    height="24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    fillRule="evenodd"
                    clipRule="evenodd"
                >
                    <path d="M12 0c6.623 0 12 5.377 12 12s-5.377 12-12 12-12-5.377-12-12 5.377-12 12-12zm0 1c6.071 0 11 4.929 11 11s-4.929 11-11 11-11-4.929-11-11 4.929-11 11-11zm.5 17h-1v-9h1v9zm-.5-12c.466 0 .845.378.845.845 0 .466-.379.844-.845.844-.466 0-.845-.378-.845-.844 0-.467.379-.845.845-.845z" />
                </svg>
            );
        case 'search':
            return (
                <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488.4 488.4">
                    <g>
                        <g>
                            <path
                                d="M0,203.25c0,112.1,91.2,203.2,203.2,203.2c51.6,0,98.8-19.4,134.7-51.2l129.5,129.5c2.4,2.4,5.5,3.6,8.7,3.6
                            s6.3-1.2,8.7-3.6c4.8-4.8,4.8-12.5,0-17.3l-129.6-129.5c31.8-35.9,51.2-83,51.2-134.7c0-112.1-91.2-203.2-203.2-203.2
                            S0,91.15,0,203.25z M381.9,203.25c0,98.5-80.2,178.7-178.7,178.7s-178.7-80.2-178.7-178.7s80.2-178.7,178.7-178.7
                            S381.9,104.65,381.9,203.25z"
                            />
                        </g>
                    </g>
                </svg>
            );
        case 'timer':
            return (
                <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10 4.25C10 5.17826 9.63125 6.0685 8.97487 6.72487C8.3185 7.38125 7.42826 7.75 6.5 7.75C5.57174 7.75 4.6815 7.38125 4.02513 6.72487C3.36875 6.0685 3 5.17826 3 4.25V1.25H10V4.25Z"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M10 11.25C10 10.3217 9.63125 9.4315 8.97487 8.77513C8.3185 8.11875 7.42826 7.75 6.5 7.75C5.57174 7.75 4.6815 8.11875 4.02513 8.77513C3.36875 9.4315 3 10.3217 3 11.25V14.25H10V11.25Z"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path d="M1 1.25H12" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M1 14.75H12" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            );
        case 'bet':
            return (
                <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_134_1651)">
                        <path
                            d="M15.9999 3.11133V9.38825C15.9999 10.8327 12.4871 12.0036 8.15377 12.0036C3.82046 12.0036 0.307617 10.8327 0.307617 9.38825V3.11133"
                            fill="#FFDB2D"
                        />
                        <path
                            d="M8.15375 3.11133V12.0036C12.4871 12.0036 15.9999 10.8327 15.9999 9.38825V3.11133H8.15375Z"
                            fill="#FFAF33"
                        />
                        <path
                            d="M8.15377 5.72684C12.4871 5.72684 15.9999 4.5559 15.9999 3.11147C15.9999 1.66704 12.4871 0.496094 8.15377 0.496094C3.82046 0.496094 0.307617 1.66704 0.307617 3.11147C0.307617 4.5559 3.82046 5.72684 8.15377 5.72684Z"
                            fill="#FFEA8A"
                        />
                        <path
                            d="M8.15375 0.496094V5.72687C12.4871 5.72687 15.9999 4.55593 15.9999 3.1115C15.9999 1.66707 12.4871 0.496094 8.15375 0.496094Z"
                            fill="#FFDB2D"
                        />
                        <path
                            d="M8.15377 8.0812C3.82046 8.0812 0.307617 6.91025 0.307617 5.46582V7.96896C0.770019 8.27015 1.35998 8.55402 2.10947 8.80391C3.74724 9.3498 5.89377 9.65046 8.15377 9.65046C10.4138 9.65046 12.5603 9.3498 14.1981 8.80391C14.9476 8.55408 15.5376 8.27015 15.9999 7.96896V5.46582C15.9999 6.91025 12.4871 8.0812 8.15377 8.0812Z"
                            fill="#FFAF33"
                        />
                        <path
                            d="M8.15375 8.0812V9.65043C10.4137 9.65043 12.5603 9.34976 14.198 8.80387C14.9476 8.55405 15.5375 8.27012 15.9999 7.96893V5.46582C15.9999 6.91025 12.4871 8.0812 8.15375 8.0812Z"
                            fill="#FF9408"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_134_1651">
                            <rect width="15.6923" height="12" fill="white" transform="translate(0.307617 0.25)" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case 'users':
            return (
                <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M5.5 1.75C5.77614 1.75 6 1.52614 6 1.25C6 0.973858 5.77614 0.75 5.5 0.75V1.75ZM5.5 6.11364C5.77614 6.11364 6 5.88978 6 5.61364C6 5.33749 5.77614 5.11364 5.5 5.11364V6.11364ZM4.53415 8.26989C4.79593 8.18199 4.93689 7.89852 4.84899 7.63674C4.7611 7.37497 4.47763 7.23401 4.21585 7.3219L4.53415 8.26989ZM1 12.1102L0.5 12.1095V12.1102H1ZM1 13.2504H0.5C0.5 13.5266 0.723858 13.7504 1 13.7504V13.2504ZM2.74569 13.7504C3.02183 13.7504 3.24569 13.5266 3.24569 13.2504C3.24569 12.9743 3.02183 12.7504 2.74569 12.7504V13.7504ZM13.5 13.25V13.75C13.7761 13.75 14 13.5261 14 13.25H13.5ZM4.5 13.25H4C4 13.5261 4.22386 13.75 4.5 13.75V13.25ZM4.5 12.25H4H4.5ZM9 7.75V7.25V7.75ZM12.5 0.75C12.2239 0.75 12 0.973858 12 1.25C12 1.52614 12.2239 1.75 12.5 1.75V0.75ZM12.5 5.25C12.2239 5.25 12 5.47386 12 5.75C12 6.02614 12.2239 6.25 12.5 6.25V5.25ZM14.2779 7.4731C14.0198 7.37492 13.731 7.50455 13.6328 7.76265C13.5346 8.02075 13.6642 8.30957 13.9223 8.40776L14.2779 7.4731ZM17.0001 12.1404H17.5001V12.1398L17.0001 12.1404ZM17.0001 13.2504V13.7504C17.2762 13.7504 17.5001 13.5266 17.5001 13.2504H17.0001ZM15.5001 12.7504C15.224 12.7504 15.0001 12.9743 15.0001 13.2504C15.0001 13.5266 15.224 13.7504 15.5001 13.7504V12.7504ZM5.5 0.75C4.77553 0.75 4.07776 1.02893 3.56094 1.53009L4.25708 2.24799C4.58417 1.93081 5.03099 1.75 5.5 1.75V0.75ZM3.56094 1.53009C3.04359 2.03176 2.75 2.7155 2.75 3.43182H3.75C3.75 2.99082 3.93052 2.56466 4.25708 2.24799L3.56094 1.53009ZM2.75 3.43182C2.75 4.14813 3.04359 4.83188 3.56094 5.33355L4.25708 4.61565C3.93052 4.29897 3.75 3.87281 3.75 3.43182H2.75ZM3.56094 5.33355C4.07776 5.83471 4.77553 6.11364 5.5 6.11364V5.11364C5.03099 5.11364 4.58417 4.93282 4.25708 4.61565L3.56094 5.33355ZM4.21585 7.3219C3.13844 7.68367 2.20087 8.32893 1.53368 9.18181L2.32131 9.79795C2.85945 9.11004 3.62884 8.57387 4.53415 8.26989L4.21585 7.3219ZM1.53368 9.18181C0.865679 10.0357 0.501578 11.0566 0.500001 12.1095L1.5 12.111C1.50123 11.2914 1.78399 10.4848 2.32131 9.79795L1.53368 9.18181ZM0.5 12.1102V13.2504H1.5V12.1102H0.5ZM1 13.7504H2.74569V12.7504H1V13.7504ZM10.75 3.5C10.75 4.4665 9.9665 5.25 9 5.25V6.25C10.5188 6.25 11.75 5.01878 11.75 3.5H10.75ZM9 5.25C8.0335 5.25 7.25 4.4665 7.25 3.5H6.25C6.25 5.01878 7.48122 6.25 9 6.25V5.25ZM7.25 3.5C7.25 2.5335 8.0335 1.75 9 1.75V0.75C7.48122 0.75 6.25 1.98122 6.25 3.5H7.25ZM9 1.75C9.9665 1.75 10.75 2.5335 10.75 3.5H11.75C11.75 1.98122 10.5188 0.75 9 0.75V1.75ZM13.5 12.75H4.5V13.75H13.5V12.75ZM5 13.25V12.25H4V13.25H5ZM5 12.25C5 11.1891 5.42143 10.1717 6.17157 9.42157L5.46447 8.71447C4.52678 9.65215 4 10.9239 4 12.25H5ZM6.17157 9.42157C6.92172 8.67143 7.93913 8.25 9 8.25V7.25C7.67392 7.25 6.40215 7.77678 5.46447 8.71447L6.17157 9.42157ZM9 8.25C10.0609 8.25 11.0783 8.67143 11.8284 9.42157L12.5355 8.71447C11.5979 7.77678 10.3261 7.25 9 7.25V8.25ZM11.8284 9.42157C12.5786 10.1717 13 11.1891 13 12.25H14C14 10.9239 13.4732 9.65215 12.5355 8.71447L11.8284 9.42157ZM13 12.25V13.25H14V12.25H13ZM12.5 1.75C12.9641 1.75 13.4092 1.93437 13.7374 2.26256L14.4445 1.55546C13.9288 1.03973 13.2293 0.75 12.5 0.75V1.75ZM13.7374 2.26256C14.0656 2.59075 14.25 3.03587 14.25 3.5H15.25C15.25 2.77065 14.9603 2.07118 14.4445 1.55546L13.7374 2.26256ZM14.25 3.5C14.25 3.96413 14.0656 4.40925 13.7374 4.73744L14.4445 5.44454C14.9603 4.92882 15.25 4.22935 15.25 3.5H14.25ZM13.7374 4.73744C13.4092 5.06563 12.9641 5.25 12.5 5.25V6.25C13.2293 6.25 13.9288 5.96027 14.4445 5.44454L13.7374 4.73744ZM13.9223 8.40776C14.6795 8.6958 15.3314 9.20697 15.7917 9.87362L16.6146 9.30543C16.0392 8.47212 15.2244 7.83316 14.2779 7.4731L13.9223 8.40776ZM15.7917 9.87362C16.252 10.5403 16.499 11.331 16.5001 12.1411L17.5001 12.1398C17.4988 11.1271 17.19 10.1387 16.6146 9.30543L15.7917 9.87362ZM16.5001 12.1404V13.2504H17.5001V12.1404H16.5001ZM17.0001 12.7504H15.5001V13.7504H17.0001V12.7504Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case 'add-party':
            return (
                <svg width="19" height="26" viewBox="0 0 19 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M8.16551 13.0154V15.9551H10.9505V16.574H8.16551V19.5136H7.54663V16.574H4.76168V15.9551H7.54663V13.0154H8.16551Z"
                        fill="white"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M3.26501 5.53478L3.71916 7.67139H3.67864C2.31145 7.67139 1.20312 8.77972 1.20312 10.1469V22.5245C1.20312 23.8917 2.31145 25 3.67864 25H11.1052C12.4724 25 13.5807 23.8917 13.5807 22.5245V18.527L16.0388 18.0045C17.3761 17.7203 18.2298 16.4057 17.9455 15.0684L15.3721 2.96133C15.0878 1.62402 13.7733 0.770349 12.436 1.0546L5.17174 2.59867C3.83443 2.88292 2.98076 4.19747 3.26501 5.53478ZM12.5647 1.65996L5.30041 3.20402C4.29743 3.41722 3.65717 4.40312 3.87036 5.40611L4.35187 7.67139H11.5336C12.7299 7.67139 13.6997 8.64118 13.6997 9.83747V17.869L15.9101 17.3992C16.9131 17.186 17.5534 16.2001 17.3402 15.1971L14.7667 3.09001C14.5536 2.08702 13.5677 1.44677 12.5647 1.65996ZM3.67864 8.29027H11.1052C12.1306 8.29027 12.9618 9.12152 12.9618 10.1469V22.5245C12.9618 23.5499 12.1306 24.3811 11.1052 24.3811H3.67864C2.65325 24.3811 1.822 23.5499 1.822 22.5245V10.1469C1.822 9.12152 2.65325 8.29027 3.67864 8.29027Z"
                        fill="white"
                    />
                    <path
                        d="M3.71916 7.67139V8.17139H4.33661L4.20824 7.56744L3.71916 7.67139ZM3.26501 5.53478L2.77594 5.63873L3.26501 5.53478ZM13.5807 18.527L13.4767 18.038L13.0807 18.1221V18.527H13.5807ZM16.0388 18.0045L15.9349 17.5155H15.9349L16.0388 18.0045ZM17.9455 15.0684L18.4346 14.9645V14.9645L17.9455 15.0684ZM15.3721 2.96133L15.8612 2.85738V2.85738L15.3721 2.96133ZM12.436 1.0546L12.54 1.54368L12.436 1.0546ZM5.17174 2.59867L5.06778 2.1096H5.06778L5.17174 2.59867ZM5.30041 3.20402L5.19646 2.71495H5.19646L5.30041 3.20402ZM12.5647 1.65996L12.6686 2.14903L12.5647 1.65996ZM3.87036 5.40611L3.38129 5.51006L3.87036 5.40611ZM4.35187 7.67139L3.86279 7.77535L3.94697 8.17139H4.35187V7.67139ZM11.5336 7.67139V7.17139V7.67139ZM13.6997 17.869H13.1997V18.4865L13.8036 18.3581L13.6997 17.869ZM15.9101 17.3992L15.8062 16.9101H15.8062L15.9101 17.3992ZM17.3402 15.1971L17.8293 15.0931V15.0931L17.3402 15.1971ZM14.7667 3.09001L15.2558 2.98605V2.98605L14.7667 3.09001ZM8.16551 15.9551H7.66551V16.4551H8.16551V15.9551ZM8.16551 13.0154H8.66551V12.5154H8.16551V13.0154ZM10.9505 15.9551H11.4505V15.4551H10.9505V15.9551ZM10.9505 16.574V17.074H11.4505V16.574H10.9505ZM8.16551 16.574V16.074H7.66551V16.574H8.16551ZM8.16551 19.5136V20.0136H8.66551V19.5136H8.16551ZM7.54663 19.5136H7.04663V20.0136H7.54663V19.5136ZM7.54663 16.574H8.04663V16.074H7.54663V16.574ZM4.76168 16.574H4.26168V17.074H4.76168V16.574ZM4.76168 15.9551V15.4551H4.26168V15.9551H4.76168ZM7.54663 15.9551V16.4551H8.04663V15.9551H7.54663ZM7.54663 13.0154V12.5154H7.04663V13.0154H7.54663ZM4.20824 7.56744L3.75408 5.43082L2.77594 5.63873L3.23009 7.77535L4.20824 7.56744ZM3.67864 8.17139H3.71916V7.17139H3.67864V8.17139ZM1.70312 10.1469C1.70312 9.05586 2.58759 8.17139 3.67864 8.17139V7.17139C2.03531 7.17139 0.703125 8.50358 0.703125 10.1469H1.70312ZM1.70312 22.5245V10.1469H0.703125V22.5245H1.70312ZM3.67864 24.5C2.58759 24.5 1.70312 23.6155 1.70312 22.5245H0.703125C0.703125 24.1678 2.03531 25.5 3.67864 25.5V24.5ZM11.1052 24.5H3.67864V25.5H11.1052V24.5ZM13.0807 22.5245C13.0807 23.6155 12.1962 24.5 11.1052 24.5V25.5C12.7485 25.5 14.0807 24.1678 14.0807 22.5245H13.0807ZM13.0807 18.527V22.5245H14.0807V18.527H13.0807ZM15.9349 17.5155L13.4767 18.038L13.6847 19.0161L16.1428 18.4936L15.9349 17.5155ZM17.4565 15.1724C17.6833 16.2396 17.0021 17.2886 15.9349 17.5155L16.1428 18.4936C17.7502 18.1519 18.7763 16.5719 18.4346 14.9645L17.4565 15.1724ZM14.883 3.06529L17.4565 15.1724L18.4346 14.9645L15.8612 2.85738L14.883 3.06529ZM12.54 1.54368C13.6072 1.31684 14.6562 1.99809 14.883 3.06529L15.8612 2.85738C15.5195 1.24996 13.9395 0.223862 12.332 0.56553L12.54 1.54368ZM5.2757 3.08774L12.54 1.54368L12.332 0.56553L5.06778 2.1096L5.2757 3.08774ZM3.75408 5.43082C3.52724 4.36362 4.20849 3.31458 5.2757 3.08774L5.06778 2.1096C3.46036 2.45126 2.43427 4.03131 2.77594 5.63873L3.75408 5.43082ZM5.40437 3.6931L12.6686 2.14903L12.4607 1.17089L5.19646 2.71495L5.40437 3.6931ZM4.35944 5.30215C4.20366 4.56927 4.67149 3.84888 5.40437 3.6931L5.19646 2.71495C3.92336 2.98555 3.11069 4.23697 3.38129 5.51006L4.35944 5.30215ZM4.84094 7.56744L4.35944 5.30215L3.38129 5.51006L3.86279 7.77535L4.84094 7.56744ZM11.5336 7.17139H4.35187V8.17139H11.5336V7.17139ZM14.1997 9.83747C14.1997 8.36504 13.006 7.1714 11.5336 7.17139V8.17139C12.4538 8.17139 13.1997 8.91732 13.1997 9.83747H14.1997ZM14.1997 17.869V9.83747H13.1997V17.869H14.1997ZM15.8062 16.9101L13.5957 17.38L13.8036 18.3581L16.0141 17.8883L15.8062 16.9101ZM16.8511 15.3011C17.0069 16.0339 16.5391 16.7543 15.8062 16.9101L16.0141 17.8883C17.2872 17.6177 18.0999 16.3662 17.8293 15.0931L16.8511 15.3011ZM14.2777 3.19396L16.8511 15.3011L17.8293 15.0931L15.2558 2.98605L14.2777 3.19396ZM12.6686 2.14903C13.4015 1.99326 14.1219 2.46109 14.2777 3.19396L15.2558 2.98605C14.9852 1.71296 13.7338 0.900281 12.4607 1.17089L12.6686 2.14903ZM11.1052 7.79027H3.67864V8.79027H11.1052V7.79027ZM13.4618 10.1469C13.4618 8.84538 12.4067 7.79027 11.1052 7.79027V8.79027C11.8544 8.79027 12.4618 9.39766 12.4618 10.1469H13.4618ZM13.4618 22.5245V10.1469H12.4618V22.5245H13.4618ZM11.1052 24.8811C12.4067 24.8811 13.4618 23.826 13.4618 22.5245H12.4618C12.4618 23.2737 11.8544 23.8811 11.1052 23.8811V24.8811ZM3.67864 24.8811H11.1052V23.8811H3.67864V24.8811ZM1.322 22.5245C1.322 23.826 2.37711 24.8811 3.67864 24.8811V23.8811C2.92939 23.8811 2.322 23.2737 2.322 22.5245H1.322ZM1.322 10.1469V22.5245H2.322V10.1469H1.322ZM3.67864 7.79027C2.37711 7.79027 1.322 8.84538 1.322 10.1469H2.322C2.322 9.39766 2.92939 8.79027 3.67864 8.79027V7.79027ZM8.66551 15.9551V13.0154H7.66551V15.9551H8.66551ZM10.9505 15.4551H8.16551V16.4551H10.9505V15.4551ZM11.4505 16.574V15.9551H10.4505V16.574H11.4505ZM8.16551 17.074H10.9505V16.074H8.16551V17.074ZM8.66551 19.5136V16.574H7.66551V19.5136H8.66551ZM7.54663 20.0136H8.16551V19.0136H7.54663V20.0136ZM7.04663 16.574V19.5136H8.04663V16.574H7.04663ZM4.76168 17.074H7.54663V16.074H4.76168V17.074ZM4.26168 15.9551V16.574H5.26168V15.9551H4.26168ZM7.54663 15.4551H4.76168V16.4551H7.54663V15.4551ZM7.04663 13.0154V15.9551H8.04663V13.0154H7.04663ZM8.16551 12.5154H7.54663V13.5154H8.16551V12.5154Z"
                        fill="white"
                    />
                </svg>
            );
        case 'settings':
            return (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.0175 19C10.6601 19 10.3552 18.7347 10.297 18.373C10.2434 18.0804 10.038 17.8413 9.76171 17.75C9.53658 17.6707 9.31645 17.5772 9.10261 17.47C8.84815 17.3365 8.54289 17.3565 8.30701 17.522C8.02156 17.7325 7.62943 17.6999 7.38076 17.445L6.41356 16.453C6.15326 16.186 6.11944 15.7651 6.33361 15.458C6.49878 15.2105 6.52257 14.8914 6.39601 14.621C6.31262 14.4332 6.23906 14.2409 6.17566 14.045C6.08485 13.7363 5.8342 13.5051 5.52533 13.445C5.15287 13.384 4.8779 13.0559 4.87501 12.669V11.428C4.87303 10.9821 5.18705 10.6007 5.61601 10.528C5.94143 10.4645 6.21316 10.2359 6.33751 9.921C6.37456 9.83233 6.41356 9.74433 6.45451 9.657C6.61989 9.33044 6.59705 8.93711 6.39503 8.633C6.1424 8.27288 6.18119 7.77809 6.48668 7.464L7.19746 6.735C7.54802 6.37532 8.1009 6.32877 8.50396 6.625L8.52638 6.641C8.82735 6.84876 9.21033 6.88639 9.54428 6.741C9.90155 6.60911 10.1649 6.29424 10.2375 5.912L10.2473 5.878C10.3275 5.37197 10.7536 5.00021 11.2535 5H12.1115C12.6248 4.99976 13.0629 5.38057 13.1469 5.9L13.1625 5.97C13.2314 6.33617 13.4811 6.63922 13.8216 6.77C14.1498 6.91447 14.5272 6.87674 14.822 6.67L14.8707 6.634C15.2842 6.32834 15.8528 6.37535 16.2133 6.745L16.8675 7.417C17.1954 7.75516 17.2366 8.28693 16.965 8.674C16.7522 8.99752 16.7251 9.41325 16.8938 9.763L16.9358 9.863C17.0724 10.2045 17.3681 10.452 17.7216 10.521C18.1837 10.5983 18.5235 11.0069 18.525 11.487V12.6C18.5249 13.0234 18.2263 13.3846 17.8191 13.454C17.4842 13.5199 17.2114 13.7686 17.1083 14.102C17.0628 14.2353 17.0121 14.3687 16.9562 14.502C16.8261 14.795 16.855 15.1364 17.0323 15.402C17.2662 15.7358 17.2299 16.1943 16.9465 16.485L16.0388 17.417C15.7792 17.6832 15.3698 17.7175 15.0716 17.498C14.8226 17.3235 14.5001 17.3043 14.2331 17.448C14.0428 17.5447 13.8475 17.6305 13.6481 17.705C13.3692 17.8037 13.1636 18.0485 13.1099 18.346C13.053 18.7203 12.7401 18.9972 12.3708 19H11.0175Z"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.9747 12C13.9747 13.2885 12.9563 14.333 11.7 14.333C10.4437 14.333 9.42533 13.2885 9.42533 12C9.42533 10.7115 10.4437 9.66699 11.7 9.66699C12.9563 9.66699 13.9747 10.7115 13.9747 12Z"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case 'user':
            return (
                <svg width="12" height="12" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fill="currentColor"
                        d="M288 320a224 224 0 1 0 448 0 224 224 0 1 0-448 0zm544 608H160a32 32 0 0 1-32-32v-96a160 160 0 0 1 160-160h448a160 160 0 0 1 160 160v96a32 32 0 0 1-32 32z"
                    />
                </svg>
            );
        case 'lock':
            return (
                <svg
                    fill="currentColor"
                    width="16"
                    height="16"
                    viewBox="0 0 256 256"
                    id="Flat"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M208,84H168V52a40,40,0,0,0-80,0V84H48A12.01375,12.01375,0,0,0,36,96V208a12.01375,12.01375,0,0,0,12,12H208a12.01375,12.01375,0,0,0,12-12V96A12.01375,12.01375,0,0,0,208,84ZM96,52a32,32,0,0,1,64,0V84H96ZM212,208a4.00458,4.00458,0,0,1-4,4H48a4.00458,4.00458,0,0,1-4-4V96a4.00458,4.00458,0,0,1,4-4H208a4.00458,4.00458,0,0,1,4,4Zm-76.00586-56a8,8,0,1,1-8-8A8.00917,8.00917,0,0,1,135.99414,152Z" />
                </svg>
            );
        case 'unlock':
            return (
                <svg
                    fill="currentColor"
                    width="16"
                    height="16"
                    viewBox="0 0 256 256"
                    id="Flat"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M208,84H96V52a32,32,0,0,1,64,0,4,4,0,0,0,8,0,40,40,0,0,0-80,0V84H48A12.01375,12.01375,0,0,0,36,96V208a12.01375,12.01375,0,0,0,12,12H208a12.01375,12.01375,0,0,0,12-12V96A12.01375,12.01375,0,0,0,208,84Zm4,124a4.00458,4.00458,0,0,1-4,4H48a4.00458,4.00458,0,0,1-4-4V96a4.00458,4.00458,0,0,1,4-4H208a4.00458,4.00458,0,0,1,4,4Zm-76.00586-56a8,8,0,1,1-8-8A8.00917,8.00917,0,0,1,135.99414,152Z" />
                </svg>
            );
        case 'check':
            return (
                <span className="icon icon16">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M20.7072 7.70711C21.0977 7.31658 21.0977 6.68342 20.7072 6.29289C20.3166 5.90237 19.6835 5.90237 19.293 6.29289L20.7072 7.70711ZM9.0001 18L8.29301 18.7071C8.68353 19.0976 9.31669 19.0976 9.70721 18.7071L9.0001 18ZM4.7071 12.2929C4.31657 11.9024 3.6834 11.9024 3.29288 12.2929C2.90236 12.6834 2.90237 13.3166 3.2929 13.7071L4.7071 12.2929ZM19.293 6.29289L8.293 17.2929L9.70721 18.7071L20.7072 7.70711L19.293 6.29289ZM3.2929 13.7071L8.29301 18.7071L9.7072 17.2928L4.7071 12.2929L3.2929 13.7071Z"
                            fill="white"
                        />
                    </svg>
                </span>
            );
        default:
            return <></>;
    }
};

export default SvgIcon;
